// extracted by mini-css-extract-plugin
export default {"intro":"MovieDetail_intro__UFhiI","awards":"MovieDetail_awards__uqhfJ","award":"MovieDetail_award__EwpZ3","line":"MovieDetail_line__wmI-h","image":"MovieDetail_image__Mz4jG"};